<template>
  <infinite-list-autocomplete
    :selectedName="selectedCorporation"
    :data="getCorporationsList"
    :listSearchParams="searchParams"
    :totalCount="totalCount"
    :placeholder="$t('components.corporationSelect.selectCorporation')"
    :disabled="disabled"
    :clearable="false"
    @selectItem="selectItem"
    @intersect="increaceIntersection"
  >
    <template v-slot:prependIcon>
      <department-icon/>
    </template>
    <template v-slot:appendIcon>
      <v-icon>mdi-chevron-down</v-icon>
    </template>
  </infinite-list-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconLoader } from '@/helpers/iconsLoader';
import InfiniteListAutocomplete from '@/components/elements/InfiniteListAutocomplete.vue';

const defaultState = {
  page: 0,
  maxPerPage: 10,
  sort: 'name',
};

export default {
  name: 'corporations-selector',
  components: {
    InfiniteListAutocomplete,
    ...iconLoader.sideMenu,
  },
  props: {
    setSelected: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      selectedCorporation: null,
      searchParams: defaultState,
      totalCount: 0,
    };
  },
  async mounted() {
    if (!this.getCorporationsList.length) await this.loadData();

    if (this.getSelectedCorporationId) {
      this.setCorporation();

      if (!this.selectedCorporation) {
        this.increaceIntersection();

        this.setCorporation();
      }

      return true;
    }

    if (this.getCorporationsList.length) {
      this.selectedCorporation = this.getCorporationsList[0].id;
    }

    return true;
  },
  computed: {
    ...mapGetters('corporations', ['getSelectedCorporationId', 'getCorporationsList']),
  },
  watch: {
    selectedCorporation(val) {
      if (this.setSelected) this.$store.commit('corporations/setCorporationId', val);
    },
  },
  methods: {
    selectItem(val) {
      this.$emit('onSelectedItem', val);
      if (val) {
        this.selectedCorporation = val.id;
        return true;
      }
      this.selectedCorporation = null;
      return false;
    },
    setCorporation() {
      this.selectedCorporation = this.getCorporationsList.find((el) => el.id === this.getSelectedCorporationId).id;
    },
    async increaceIntersection() {
      this.searchParams.page += 1;
      this.intersection = true;
      await this.loadData();
    },
    formatHeaders(headers) {
      return Number(headers['x-total-count'] || 0);
    },
    async loadData() {
      let updatedData = null;
      const { data, headers } = await this.$store.dispatch('corporations/listCorporations', { ...this.searchParams });

      if (!this.totalCount) this.totalCount = this.formatHeaders(headers);

      if (this.intersection) {
        updatedData = [...this.getCorporationsList, ...data];
      }

      this.$store.commit('corporations/setCorporations', updatedData || data);
    },
  },
};
</script>
